import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from '../../../services/users/user.service';
import { formatDate } from '@angular/common';
import { ReporteService } from 'src/app/services/reportes/reporte.service';
import { AuthService } from 'src/app/services/authFirebase/auth.service';
import { Task } from 'src/app/models/task';
import { UserData } from 'src/app/models/user';
import { logClient } from 'src/app/models/logs';
import { isArray } from 'rxjs/internal-compatibility';
import { MatDialogRef } from '@angular/material';
import { Call } from 'src/app/models/call';
import { ActionsClient } from 'src/app/models/report-agent';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { CallsReportsService } from 'src/app/services/calls-reports/calls-reports.service';
import { CompanyService } from 'src/app/services/company/company.service';
import { Prospect } from 'src/app/models/prospects';

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {

  public users: any = []
  public addForm: FormGroup;
  public minDate: Date;
  public loading = false;
  public downloanding: string;
  public currentUser: string
  private extraTime: number = 0;
  private logsReports = []
  private callsReport: Call[] = []
  private callsOutReport: Call[] = []
  private reportStartDate: Date;
  private reportEndDate: Date;
  constructor(
    public ref: MatDialogRef<GenerateReportComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private usersService: UserService,
    private reportService: ReporteService,
    private service: AuthService,
    private prospectService: ProspectsService,
    private callService: CallsReportsService,
    private companyService: CompanyService
  ) { }

  async ngOnInit() {
    this.addForm = this.formBuilder.group({
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      agente: ["", Validators.required],
    });
    this.currentUser = localStorage.getItem("currentUser")
    if (this.currentUser == "administrador") {
      this.users = await this.getAgents()
    } else {
      this.users = await this.getCurrentUser();
    }
  }

  async getAgents() {
    try {
      return await this.usersService.getActiveUsers();
    } catch (error) {
      Swal.fire({
        title: 'Ocurrió un error al obtener los datos',
        text: "Si el problema persiste, favor de reportar el error",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      })
    }
  }

  async getCurrentUser() {
    try {
      let user = this.service.currentuser();
      return await this.usersService.getUserById(user.uid);
    } catch (error) {
      Swal.fire({
        title: 'Ocurrió un error al obtener los datos',
        text: "Si el problema persiste, favor de reportar el error",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      })
    }
  }

  async getCalls(start: any, end: any) {
    try {
      start = new Date(start).getTime().toString()
      end = new Date(end).getTime().toString()
      const response = await this.callService.getAllCalls('%20', start, end)
      return response;
    } catch (error) {
      this.loading = false;
      this.ref.close();
      document.removeEventListener('click', enableClick, true)
      if (error.error.status == 504) {
        Swal.fire({
          icon: 'error',
          title: "Ocurrió un error externo al servidor",
          text: "No se pudo acceder al servicio http://134.122.14.131:9020, para consultar informacion de las llamadas, si el problema persiste favor de ponerse en contacto con el area de TI de MIA"
        })
      } else {
        Swal.fire({
          position: "center",
          icon: 'error',
          title: "Ocurrió un error al crear los datos",
          text: "Intente de nuevo más tarde",
          showConfirmButton: true,
        });
      }
    }
  }

  async getCallsOut(start: any, end: any) {
    try {
      start = new Date(start).getTime()
      end = new Date(end).getTime()
      const response = await this.callService.getOutgoinCalls('%20', start, end)
      
      return response;
    } catch (error) {
      this.loading = false;
      this.ref.close();
      document.removeEventListener('click', enableClick, true)
      if (error.error.status == 504) {
        Swal.fire({
          icon: 'error',
          title: "Ocurrió un error externo al servidor",
          text: "No se pudo acceder al servicio http://134.122.14.131:9020, para consultar informacion de las llamadas, si el problema persiste favor de ponerse en contacto con el area de TI de MIA"
        })
      } else {
        Swal.fire({
          position: "center",
          icon: 'error',
          title: "Ocurrió un error al crear los datos",
          text: "Intente de nuevo más tarde",
          showConfirmButton: true,
        });
      }
    }
  }

  onSelectedStartDate(event) {
    var date = new Date(event);
    date.setDate(date.getDate() + 1);
    this.minDate = new Date(event);
  }

  async submit() {
    const form = this.addForm.value;
    if (form.start_date == "" || form.end_date == "") {
      this.ref.close();
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Seleccione una rango de fecha para crear el reporte',
        showConfirmButton: true,
      })
      return
    } else {
      this.loading = true
      document.addEventListener('click', enableClick, true);
      if (this.currentUser != "administrador") {
        form.agente = this.users.nombre
      }     
      const start = new Date(form.start_date);
      start.setHours(0, 0, 0, 0);

      const end = new Date(form.end_date);
      end.setHours(23, 59, 59, 999);

      form.start_date = start;
      form.end_date = end;
      this.reportStartDate = start;
      this.reportEndDate = end;
      this.logsReports = await this.getLogsCompanies(form.start_date, form.end_date)
      this.callsReport = await this.getCalls(form.start_date.toString(), form.end_date.toString())
      this.callsOutReport = await this.getCallsOut(form.start_date.toString(), form.end_date.toString())
      this.createReport(form);
    }
  }

  private async createReport(form) {
    try {
      this.loading = true
      this.downloanding = "Consultando empresas..."
      var reportData: any = [];
      var time_start_date = form.start_date.getTime();
      var time_end_date = form.end_date.getTime();
      var day_start = formatDate(new Date(time_start_date), 'dd', 'en-US');
      var month_start = formatDate(new Date(time_start_date), 'MMMM', 'es-MX');
      var year_start = formatDate(new Date(time_start_date), 'yyy', 'en-US');
      const start_date_txt = day_start + ' de ' + month_start + " de " + year_start;
      var day_end = formatDate(new Date(time_end_date), 'dd', 'en-US');
      var month_end = formatDate(new Date(time_end_date), 'MMMM', 'es-MX');
      var year_end = formatDate(new Date(time_end_date), 'yyy', 'en-US');
      const end_date_txt = day_end + ' de ' + month_end + " de " + year_end;
      if (form.agente == "all") {
        for await (const user of this.users) {
          form.agente = user.nombre
          reportData = await this.findDataInProspects(form.agente)
          var response = await this.reportService.addAgentReport({
            report: 'Reporte del ' + start_date_txt + ' al ' + end_date_txt,
            date: new Date(),
            format_start_date: start_date_txt,
            format_end_date: end_date_txt,
            clients: reportData,
            agente: form.agente
          })
        }
        document.removeEventListener('click', enableClick, true)
        this.ref.close();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Se han creado todos los reportes",
          showConfirmButton: true,
        });
        this.router.navigate(['/reporte-agentes'])
      } else {
        reportData = await this.findDataInProspects(form.agente)
        var response = await this.reportService.addAgentReport({
          report: 'Reporte del ' + start_date_txt + ' al ' + end_date_txt,
          date: new Date(),
          format_start_date: start_date_txt,
          format_end_date: end_date_txt,
          clients: reportData,
          agente: form.agente
        })
        if (response.code == 200) {
          this.loading = false;
          this.ref.close();
          document.removeEventListener('click', enableClick, true)
          this.router.navigate(['/reporte-agentes-details/' + response.data])
        }
      }
    } catch (error) {
      console.log(error);
      this.loading = false;
      this.ref.close();
      document.removeEventListener('click', enableClick, true)
      if (error.error.status == 504) {
        Swal.fire({
          icon: 'error',
          title: "Ocurrió un error externo al servidor",
          text: "No se pudo acceder al servicio http://134.122.14.131:9020, para consultar informacion de las llamadas, si el problema persiste favor de ponerse en contacto con el area de TI de MIA"
        })
      } else {
        Swal.fire({
          position: "center",
          icon: 'error',
          title: "Ocurrió un error al crear los datos",
          text: "Intente de nuevo más tarde",
          showConfirmButton: true,
        });
      }
    }
  }

async getLogsCompanies(
  startDate: any,
  endDate: any
): Promise<Array<{ logs: logClient[]; prospect: Prospect }>> {
  try {
    const reportData = [];
    const prospectList = await this.prospectService.getAllIndistecProspects();

    const hoy = new Date();
    const unMesAtras = new Date();
    unMesAtras.setMonth(unMesAtras.getMonth() - 1);

    for await (const prospect of prospectList.data) {

      if (prospect.activeInDashboard !== true) {
        const deactivationDate = prospect.deactivationComments?.createdAt 
          ? new Date(prospect.deactivationComments.createdAt) 
          : null;

        if (!deactivationDate || deactivationDate < unMesAtras || deactivationDate > hoy) {
          continue; 
        }
      }

      const logs = await this.companyService.getLogsByRange(
        startDate,
        endDate,
        prospect.uid
      );
      reportData.push({ logs, prospect });
    }

    return reportData;

  } catch (error) {
    throw error;
  }
}

  async findDataInProspects(userName: string) {
    try {
      this.loading = true;
      let userSelect: UserData;
      // Prefijos MIA
      const SPECIAL_PREFIXES = [
        '0031',
        '0098',
        '0057',
        '0005'
      ];
      if (isArray(this.users)) {
        userSelect = this.users.filter(userInfo => userInfo.nombre == userName)[0];
      } else {
        userSelect = this.users;
      }
      var arrayOfCompanies: ActionsClient[] = [];
      
      for await (const empresa of this.logsReports) {
        this.extraTime = 0;
        this.downloanding = "Consultando llamadas de la empresa...";
        const prospectInfo = empresa.prospect as Prospect;
        let phone = prospectInfo.telefono.toString();
        let indexof52 = phone.indexOf("52");
        let phoneSearch = phone.includes("52") ? indexof52 > 0 ? `52${phone}` : phone : `52${phone}`;
        let cleanPhone10 = phone.replace(/\D/g, '');
        if (cleanPhone10.length > 10) {
          cleanPhone10 = cleanPhone10.slice(-10);
        }
  
        const userExtension = userSelect.extension.toString();

        let answeredEntriesCalls = this.callsReport.filter(call => {
          const callExtension = call.extension ? call.extension.toString() : "";
          const callDstChannel = (call as any).dstchannel ? (call as any).dstchannel.toString() : "";
          const callChannel = (call as any).channel ? (call as any).channel.toString() : "";
          const callCallerId = (call as any).callerId ? (call as any).callerId.toString() : "";
          const callDid = call.did ? call.did.toString() : "";

          const implicadoEnExtension = callExtension === userExtension || callExtension.includes(`/${userExtension}-`);
          const implicadoEnDstChannel = callDstChannel.includes(`/${userExtension}-`);
          const implicadoEnChannel = callChannel.includes(`/${userExtension}-`);

          const matchPhone = 
            callDid === phoneSearch || 
            (cleanPhone10 && (callCallerId.includes(cleanPhone10) || callDid.includes(cleanPhone10)));

          if (!(call.state === "ANSWERED" && matchPhone && (implicadoEnExtension || implicadoEnDstChannel || implicadoEnChannel))) {
            return false;
          }

          const fueTransferidaAOtroAgente = this.callsReport.some(otherCall => {
            if (otherCall.state !== "ANSWERED") return false;
            const sameClient = (otherCall.callerId && otherCall.callerId === call.callerId) || (otherCall.did && otherCall.did === call.did);
            const transferidaDesdeAqui = otherCall.fila === userExtension && otherCall.extension !== userExtension;
            return sameClient && transferidaDesdeAqui;
          });

          return !fueTransferidaAOtroAgente;
        });

        let prefixesToSearch: string[] = [prospectInfo.prefix];

        if (SPECIAL_PREFIXES.includes(prospectInfo.prefix)) {
          prefixesToSearch = [...new Set([
            prospectInfo.prefix,
            ...SPECIAL_PREFIXES
          ])];
        }
        let answeredSalientesCalls = this.callsOutReport.filter(call => {
          return (
            call.extension === userSelect.extension.toString() &&
            prefixesToSearch.some(prefix =>
              call.destino && call.destino.startsWith(prefix)
            )
          );
        });

        answeredSalientesCalls = answeredSalientesCalls.filter((call) => call.state == "ANSWERED" || call.state == 'NO ANSWER');

        // Números adicionales
        if (prospectInfo.additionalPrefix != undefined) {
          for await (const iterator of prospectInfo.additionalPrefix) {
            const element = iterator.phone;
            let phoneAdd = element ? element.toString() : "";
            let indexof52Add = phoneAdd.indexOf("52");
            let phoneSearchAdd = phoneAdd.includes("52") ? indexof52Add > 0 ? `52${phoneAdd}` : phoneAdd : `52${phoneAdd}`;
            
            let cleanAdd10 = String(element || '').replace(/\D/g, '');
            if (cleanAdd10.length > 10) {
              cleanAdd10 = cleanAdd10.slice(-10);
            }

            const additionalEntriesCalls = this.callsReport.filter(
              (call) => {
                const callCallerId = (call as any).callerId ? (call as any).callerId.toString() : "";
                const callDid = call.did ? call.did.toString() : "";
                const callExtension = call.extension ? call.extension.toString() : "";
                const callDstChannel = (call as any).dstchannel ? (call as any).dstchannel.toString() : "";
                const callChannel = (call as any).channel ? (call as any).channel.toString() : "";

                const implicado = callExtension === userExtension || callExtension.includes(`/${userExtension}-`) || callDstChannel.includes(`/${userExtension}-`) || callChannel.includes(`/${userExtension}-`);
                const matchAdd = callDid === phoneSearchAdd || (cleanAdd10 && (callCallerId.includes(cleanAdd10) || callDid.includes(cleanAdd10)));

                if (!(call.state == "ANSWERED" && matchAdd && implicado)) return false;

                const fueTransferida = this.callsReport.some(otherCall => {
                  if (otherCall.state !== "ANSWERED") return false;
                  const sameClient = (otherCall.callerId && otherCall.callerId === call.callerId) || (otherCall.did && otherCall.did === call.did);
                  const transferidaDesdeAqui = otherCall.fila === userExtension && otherCall.extension !== userExtension;
                  return sameClient && transferidaDesdeAqui;
                });

                return !fueTransferida;
              }
            );
            answeredEntriesCalls = answeredEntriesCalls.concat(additionalEntriesCalls);
            
            const additionalSalientesCalls = this.callsOutReport.filter(
              (call) => call.extension == userSelect.extension.toString() && call.destino && call.destino.startsWith(iterator.prefix)
            );
            answeredSalientesCalls = answeredSalientesCalls.concat(additionalSalientesCalls.filter((call) => call.state == "ANSWERED" || call.state == 'NO ANSWER'));
          }
        }

  
        const uniqueCallsMap = new Map<string, any>();

        answeredEntriesCalls.forEach(call => {
          const callerId = (call as any).callerId || (call as any).did || call.uniqueid;
          let existingKey: string | null = null;
          for (const key of uniqueCallsMap.keys()) {
            if (key.startsWith(`${callerId}_`)) {
              existingKey = key;
              break;
            }
          }

          if (!existingKey) {
            const groupKey = `${callerId}_${call.uniqueid}`;
            uniqueCallsMap.set(groupKey, call);
          } else {
            const existingCall = uniqueCallsMap.get(existingKey);
            if ((call.duration || 0) > (existingCall.duration || 0)) {
              uniqueCallsMap.set(existingKey, call);
            }
          }
        });

        answeredEntriesCalls = Array.from(uniqueCallsMap.values());

        answeredEntriesCalls = answeredEntriesCalls.map(agentCall => {
          const clientCallerId = (agentCall as any).callerId;
          if (!clientCallerId) return agentCall;

          const matchingGeneralCalls = this.callsReport.filter(c => 
            c.state === "ANSWERED" && 
            ((c as any).callerId === clientCallerId || c.did === clientCallerId)
          );

          if (matchingGeneralCalls.length > 0) {
            const maxDurationCall = matchingGeneralCalls.reduce((max, c) => (c.duration > max.duration ? c : max), matchingGeneralCalls[0]);

            return { ...agentCall, duration: maxDurationCall.duration };
          }

          return agentCall;
        });

        answeredSalientesCalls = Array.from(new Set(answeredSalientesCalls.map(c => c.uniqueid)))
          .map(id => answeredSalientesCalls.find(c => c.uniqueid === id));

        var entriesCallTime = answeredEntriesCalls.reduce((total, call) => { return total + call.duration; }, 0);
        var outgoingCallTime = answeredSalientesCalls.reduce((total, call) => { return total + call.duration; }, 0);
        const callTime = entriesCallTime + outgoingCallTime;

        this.downloanding = "Calculando tareas...";
        const userLogs = await this.logsOfAgent(
          empresa.logs,
          userSelect,
          this.reportStartDate,
          this.reportEndDate
        );
        const tiempoTareas = (userLogs.reduce((total, log) => { return total + (log.timeTask * log.totalActions); }, 0) + this.extraTime) * 60;
        const timeWorked = callTime + tiempoTareas;

        var empresasUser: ActionsClient = {
          nombre_empresa: prospectInfo.nombre,
          plan: prospectInfo.plan,
          total_Llamadas: answeredEntriesCalls.length + answeredSalientesCalls.length,
          tiempo_llamadas: this.secondsToHms(callTime) || "0s",
          seconds_llamadas: callTime,
          total_tareas: userLogs.reduce((total, task) => { return total + task.totalActions; }, 0),
          tiempo_tareas: this.secondsToHms(tiempoTareas) || "0s",
          seconds_tareas: tiempoTareas,
          total_trabajo: this.secondsToHms(timeWorked) || "0s",
          seconds_trabajo: timeWorked
        };
        
        if (
          empresasUser.total_Llamadas > 0 || empresasUser.total_tareas > 0
        ) {
          arrayOfCompanies.push(empresasUser);
        }
        
      }
      return arrayOfCompanies;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

async logsOfAgent(
  logs: logClient[],
  userSelect: UserData,
  startDate: Date,
  endDate: Date
) {
  try {
    return logs.filter(element => {

    const rawDate: any = element.date;

    const logDate =
      rawDate instanceof Date
        ? rawDate
        : rawDate && rawDate._seconds
          ? new Date(rawDate._seconds * 1000)
          : null;

      if (!logDate) return false;

      return (
        (element.idUser === userSelect.uid ||
         element.text?.split(" por")[1] === userSelect.nombre) &&
        logDate >= startDate &&
        logDate <= endDate
      );
    });
  } catch (error) {
    throw error;
  }
}

private normalizeExtension(extension: string): string {
  if (!extension) return "";

  if (extension.startsWith("SIP/")) {
    const match = extension.match(/SIP\/(\d+)/);
    return match ? match[1] : "";
  }

  return extension;
}

  async countSMEntries(entries: Array<logClient>, asingTask: Array<Task>) {
    try {
      asingTask.map(async (task) => {
        task.quantity = 0
        task.totalAll = 0
        entries.map(logs => {
          if (logs.text.startsWith(task.title)) {
            task.quantity += 1
            task.totalAll += logs.totalActions
          }
          if (logs.timeTask != undefined && logs.text.startsWith(task.title)) {
            //Se calcula el tiempo que le tomo realizar menos el tiempo real asignado a la tarea
            var time = logs.timeTask - task.minutes
            this.additionalTimeForTasks(time);
          }
        })
      })
      return asingTask
    } catch (error) {
      throw error;
    }
  }

  additionalTimeForTasks(time: number) {
    this.extraTime += time;
  }

  secondsToHms(d) {
    try {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hr. " : " hrs. ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " min. " : " mins. ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " s." : " s.") : "";
      return hDisplay + mDisplay + sDisplay;
    } catch (error) {
      return "0s"
    }
  }

}

function enableClick(e) {
  e.stopPropagation();
  e.preventDefault();
}
